export default __webpack_public_path__ + "static/media/todo-daily.498cac3c.png";